import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var QuoteCloseIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "7",
    cy: "10",
    r: "4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M5,18a1,1,0,0,1-.2-2C5,16,9,15.06,9,10a1,1,0,0,1,2,0c0,5.39-3.8,7.58-5.8,8Z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "17",
    cy: "10",
    r: "4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15,18a1,1,0,0,1-.2-2c.18,0,4.2-1,4.2-6a1,1,0,0,1,2,0c0,5.39-3.8,7.58-5.8,8Z"
  })]
}), 'QuoteCloseIcon');